import { render } from "./MyMFGSearchTerm.vue?vue&type=template&id=6c4b736c&scoped=true"
import script from "./MyMFGSearchTerm.vue?vue&type=script&lang=js"
export * from "./MyMFGSearchTerm.vue?vue&type=script&lang=js"

import "./MyMFGSearchTerm.vue?vue&type=style&index=0&id=6c4b736c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c4b736c"]])

export default __exports__